module.exports = __webpack_public_path__ + "img/undraw-setup_wizard.b3b18e46.png";